import { render, staticRenderFns } from "./ListsMenu.vue?vue&type=template&id=10028f80"
import script from "./ListsMenu.vue?vue&type=script&lang=js"
export * from "./ListsMenu.vue?vue&type=script&lang=js"
import style0 from "./ListsMenu.vue?vue&type=style&index=0&id=10028f80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports